const DIACRITICOS_REGEX = new RegExp('[' + String.fromCharCode(0x0300) + '-' + String.fromCharCode(0x036f) + ']', 'g');

const normalizar = (texto) =>
    String(texto || '')
        .normalize('NFD')
        .replace(DIACRITICOS_REGEX, '')
        .toLowerCase();

const apenasDigitos = (texto) => String(texto || '').replace(/\D/g, '');

/** Filtra clientesPerfis por nome (acento/case-insensitive), código ou CNPJ (só dígitos). */
export const filtrarClientes = (clientesPerfis, termoBusca) => {
    const termo = (termoBusca || '').trim();
    if (!termo) {
        return clientesPerfis;
    }

    const termoNormalizado = normalizar(termo);
    const termoDigitos = apenasDigitos(termo);

    return clientesPerfis.filter((item) => {
        const nomeCombina = normalizar(item.nmCliente).includes(termoNormalizado);
        const codigoCombina = termoDigitos && `${item.cdCliente}${item.digitoCliente ?? ''}`.includes(termoDigitos);
        const cnpjCombina = termoDigitos && apenasDigitos(item.dsCnpjCpf).includes(termoDigitos);
        return nomeCombina || codigoCombina || cnpjCombina;
    });
};
